import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  AcceptSubprojectInvitationStep,
  getAcceptSubprojectInvitationStepIndex,
} from '@/features/partners/store/use-accept-subproject-invitation-store';
import {
  FlowLayout,
  FlowLayoutBody,
} from '@/shared/components/flow/flow-layout';
import { Background } from '@/shared/components/layouts/background';

export const AcceptInvitationLayout = ({
  currentStep,
  children,
}: {
  currentStep: AcceptSubprojectInvitationStep;
  children: React.ReactNode;
}) => {
  const { t } = useTranslation('subproject', { keyPrefix: 'AcceptInvitation' });
  const currentStepIndex = getAcceptSubprojectInvitationStepIndex(currentStep);

  return (
    <Background>
      <FlowLayout
        stepper={{
          steps: [
            t('info_step'),
            t('select_category_step'),
            t('set_budgets_step'),
            t('invite_members_step'),
          ],
          currentStep: currentStepIndex + 1,
        }}
      >
        <FlowLayoutBody>{children}</FlowLayoutBody>
      </FlowLayout>
    </Background>
  );
};
